import { render, staticRenderFns } from "./PropStat.vue?vue&type=template&id=6296707a&"
import script from "./PropStat.vue?vue&type=script&lang=js&"
export * from "./PropStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports